<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">Documents</h3>
        </div>
        <div class="col-auto float-right ml-auto">
          <button class="btn add-btn" @click="showAddDocumentPopup()">
            <i class="fa fa-plus"></i>Add Document
          </button>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Search Filter -->
    <div class="row">
      <div class="col-md-3" v-if="tokenObj.UserType == userTypeMainAdmin">
        <div class="form-group">
          <label>School</label>
          <select class="form-control" v-model="schoolId">
            <option value>All</option>
            <option v-for="item in schools" :value="item.Id" :key="item.Id">
              {{ item.Name }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>Name</label>
          <input
            type="text"
            placeholder="Search Name Here"
            class="form-control"
            v-model="name"
          />
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label>User Type</label>
          <select class="form-control" v-model="userTypeName">
            <option value>All</option>
            <option
              v-for="item in userTypes"
              :value="item.Name"
              :key="item.Name"
            >
              {{ item.Name }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-md-1">
        <button class="btn btn-primary filter-btn" @click="search">View</button>
      </div>
    </div>
    <!-- /Search Filter -->

    <!-- Table Result -->
    <document-table
      :uploaderUserType="tokenObj.UserType"
      :schoolId="schoolId"
      :name="name"
      :userType="userTypeName"
      :key="counter"
    ></document-table>
    <!-- /Table Result -->

    <!-- Add Document Modal -->
    <div class="modal custom-modal fade" id="addDocument" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <add-document @refreshData="refreshData"></add-document>
      </div>
    </div>
    <!-- /Add Document Modal -->
  </div>
</template>

<script>
import API from "../../../http-common.js";
import config from "../../../config.js";
import DocumentTable from "../../Shared/DocumentTable.vue";
import AddDocument from "../../Shared/DocumentAdd.vue";
import $ from "jquery";
export default {
  components: {
    DocumentTable,
    AddDocument,
  },
  data() {
    return {
      userTypeMainAdmin: config.USERTYPE_MAIN_ADMIN,
      schoolId: "",
      schools: [],
      name: "",
      userTypeName: "",
      userTypes: [],
      counter: 0,
    };
  },
  watch: {
    schoolId(val) {
      this.getDocumentUserTypes(val);
    },
  },
  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      return data;
    },
  },
  methods: {
    showAddDocumentPopup() {
      $("#addDocument").modal("show");
    },
    refreshData() {
      $("#addDocument").modal("hide");
      this.schoolId =
        this.tokenObj.UserType != this.userTypeMainAdmin
          ? this.tokenObj.SchoolId
          : "";
      this.name = "";
      this.userTypeName = "";
      this.counter++;
    },
    search() {
      //set the state from filter
      this.$store.state.documentFilter.schoolId = this.schoolId;
      this.$store.state.documentFilter.name = this.name;
      this.$store.state.documentFilter.userTypeName = this.userTypeName;
      this.counter++;
    },
    getSchools() {
      API.school
        .getSchools({ Token: this.tokenObj.Token })
        .then((response) => {
          if (response.data.success) {
            this.schools = response.data.data;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getDocumentUserTypes(schoolId) {
      API.document
        .getDocumentUserTypes({
          Token: this.tokenObj.Token,
          SchoolId: schoolId,
        })
        .then((response) => {
          if (response.data.success) {
            this.userTypes = response.data.data;
            let userType = this.userTypes.find(
              (c) => c.Name == this.userTypeName
            );
            if (!userType) this.userTypeName = "";
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
  },
  created() {
    //populate the filter from state
    let docFilter = this.$store.state.documentFilter;
    this.schoolId = docFilter.schoolId;
    this.name = docFilter.name;
    this.userTypeName = docFilter.userTypeName;
    //get school data
    if (this.tokenObj.UserType == this.userTypeMainAdmin) {
      this.getSchools();
      this.getDocumentUserTypes(this.schoolId);
    } else this.schoolId = this.tokenObj.SchoolId;

    this.counter++;
  },
};
</script>


// WEBPACK FOOTER //
// src/components/SchoolUser/SchoolAdmin/DocumentList.vue